// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Paragraph_paragraph__v9vj7","multiTitle":"Paragraph_multiTitle__q1b7q","paragraphVariant":"Paragraph_paragraphVariant__lIUrN","altColor":"Paragraph_altColor__9yehk"};